import { useForm } from 'react-hook-form'
import { Box, TextField, Typography } from '@mui/material'
import formErrorMessages from '../utils/formErrorMessages'
import Database from '../types/Database'
import MultiParagraph from './MultiParagraph'
import SaveCancelFormActions from './SaveCancelFormActions'
import theme from '../theme'

export type EditableFields =
  | 'name'
  | 'problemDescription'
  | 'solutionDescription'
  | 'marketDescription'

export type FormValues = Pick<Database.Idea, EditableFields>

type Props = {
  label: string
  fieldName: EditableFields
  onSubmit: (formValues: FormValues) => void
  onToggleEdit: (fieldName: EditableFields | void) => void
  defaultValue?: string
  isEditing?: boolean
  isDisabled?: boolean
}

const EditIdeaField = (props: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<FormValues>()
  const errorMessage = errors[props.fieldName]?.message
  const formIsOpen = props.isEditing || !props.defaultValue

  return (
    <Box
      component={'section'}
      onClick={
        !formIsOpen ? () => props.onToggleEdit(props.fieldName) : undefined
      }
      marginBottom={4}
      sx={{
        opacity: props.isDisabled ? 0.1 : 1,
        cursor: !props.isEditing && props.defaultValue ? 'pointer' : ''
      }}
    >
      <form onSubmit={handleSubmit(props.onSubmit)}>
        <Typography
          variant='h6'
          component='label'
          htmlFor={props.fieldName}
          gutterBottom
        >
          {props.label}
        </Typography>

        {!formIsOpen && props.defaultValue && (
          <MultiParagraph text={props.defaultValue} />
        )}

        {formIsOpen && (
          <>
            <TextField
              variant='filled'
              fullWidth
              id={props.fieldName}
              {...register(props.fieldName, {
                required: formErrorMessages.required
              })}
              defaultValue={props.defaultValue}
              error={!!errorMessage}
              helperText={errorMessage || ' '}
              multiline
              disabled={props.isDisabled}
              autoFocus
              sx={{
                '& .MuiFilledInput-root': {
                  paddingTop: theme.spacing(1.5),
                  lineHeight: 1.5
                },
                '& .MuiFilledInput-input': {
                  minHeight: !props.defaultValue ? 180 : ''
                }
              }}
            />

            <SaveCancelFormActions
              onClickCancel={!!props.defaultValue && props.onToggleEdit}
            />
          </>
        )}
      </form>
    </Box>
  )
}

export default EditIdeaField
